/*
 * Кольцо прогресса удержания. Класс `.hold` — глобальный, из base.css (макет Approve.html);
 * здесь только то, чего в макете нет, потому что там кольцо нарисовано статикой.
 *
 * Заливка кольца идёт `stroke-dashoffset`, а не шириной блока: круг — единственная форма,
 * по которой видно, сколько осталось, не читая цифр. Переход короткий (`--t-fast` был бы
 * длиннее шага таймера и дал бы отставание кольца от реального прогресса).
 */

.ring {
  flex: none;
  transform: rotate(-90deg);
}

/* Кольцо рисуется поверх заливки primary-кнопки, поэтому оно белое, а не фирменного цвета:
   белый здесь — не бренд, а контраст к `--violet` (так же, как текст в `.btn-pri`). Токен —
   `--on-accent`, а не `--white`: в тёмной теме `--white` — почти чёрная поверхность. */
.track {
  stroke: var(--on-accent);
  opacity: 0.32;
}

.fill {
  stroke: var(--on-accent);
  transition: stroke-dashoffset 60ms linear;
}

/* Без анимации кольца, но удержание остаётся: это предохранитель, а не украшение
   (docs/ui-design.md §8). */
@media (prefers-reduced-motion: reduce) {
  .fill {
    transition: none;
  }
}

.btn {
  border: none;
  cursor: pointer;
  touch-action: none;
  user-select: none;
}

.btnDisabled {
  background: var(--neutral-bg);
  color: var(--muted);
  cursor: default;
}
